import React from "react";

const Header = () => {
    return (
        <div className="header-container">
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className="logo"></div>
                <p className="text-main-heading">
                    <strong>Symmatics</strong> | Pay
                </p>
            </div>
            <br />
        </div>
    );
};

export default Header;